import React from 'react';
import SingleValueRadial from '@splunk/dashboard-visualizations/SingleValueRadial';

export default () => (
    <SingleValueRadial
        options={{}}
        encoding={{
            trend: 'primary[0]',
            fill: {
                field: 'primary[0]',
                format: {
                    type: 'rangevalue',
                    ranges: [
                        {
                            from: 5000,
                            value: '#A52A2A',
                        },
                        {
                            from: 1000,
                            to: 5000,
                            value: '#FFA500',
                        },
                        {
                            from: 500,
                            to: 1000,
                            value: '#FFFF00',
                        },
                        {
                            from: 100,
                            to: 500,
                            value: '#800080',
                        },
                        {
                            to: 100,
                            value: '#0000FF',
                        },
                    ],
                },
            },
        }}
        dataSources={{
            primary: {
                data: {
                    columns: [
                        ['1', '62', '103', '308', '587', '876', '930', '1320'],
                        [
                            '#FF0000',
                            '#00FFFF',
                            '#0000FF',
                            '#800080',
                            '#FFFF00',
                            '#FFA500',
                            '#A52A2A',
                            '#008000',
                        ],
                    ],
                    fields: [
                        {
                            name: 'foo',
                        },
                        {
                            name: 'bar',
                        },
                    ],
                },
                meta: {},
            },
        }}
    />
);
